// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3c454","inputWrap":"Table_inputWrap__v2lVK","col":"Table_col__3ejLr","bmiTooltip":"Table_bmiTooltip__UgHt_"};